<template>
  <div class="hello">
    <h1 style="margin-bottom:0.2em"><span style="border-bottom:3px solid #f00;padding-bottom:5px;font-size:1.3em">黄志刚<span style="color:red;">书法培训</span></span></h1>
    <h2 style="font-size:23px;margin-top:0;">专注于中小学生书法20年</h2>
    <img src="../assets/scanning.png" style="width:10em;">
    <h2 style="font-size:29px;margin-top:.2em;margin-bottom:.5em;">15659571026</h2>
    <img src="../assets/student.png" style="width:100%;border-top:3px solid #000;border-bottom:3px solid #000;">
    <h2 class="h2-title">简介</h2>
    <div style="width:95%;padding-left: .5em;">
    <p class="txt-p" style=" margin: 0 0.7em;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;黄志刚书法培训中心,是国内知名书法教育家</p>
    <p class="txt-p" style=" margin: 0 0.7em .5em 0.7em;">黄志刚先生1999年7月份创立的,<span class="p-content">专注于中小学生书
      法启蒙、硬笔字书写规范、</span>书法参赛、考级等教学,经过二十多年教学实践的经验积累,形成一套成
      熟完善的教学与管理体系,是国家文化部书法考级定点机构。</p>

    </div>
    <img src="../assets/class.png" style="width:80%;border-top:3px solid #000;border-bottom:3px solid #000;">
 <h2 class="h2-title">优势</h2>
    <div style="width:95%;padding-left: .5em;">
    <p class="txt-p">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一:教学全过程认真负责,<span class="p-content">每次课两个半小时,</span>老师先逐字解剖式讲解书写方法及要点,<span class="p-content">再一对一手把手</span>教习。
    </p>
    <p class="txt-p">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二:和家长的有效沟通，定期汇报学生学习成果及存在的问题，有针对性制定学生个性化成长方案，确保学员稳步提升。</p>
    <p class="txt-p">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三:每次课程结合教学的字讲解一个国学典故，丰富孩子的国学修养，加深对书法艺术渊源的感悟</p>
    <p class="txt-p">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;四:培养学生形成良好的学习习惯、良好的礼仪规范等。</p>

    </div>
    <p  class="col3">
      <img  src="../assets/class1.png"> 
      <img  src="../assets/class2.png"> 
      <img  src="../assets/class3.png"> </p>
      <h2 class="h2-title">效果</h2>
    <div style="width:95%;padding-left: .5em;">
    <p class="txt-p">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;二十多年来,在莆田市内培养的学生人数超6000人(每年约300多人),其中:早期的学生里
      已经成为省市区各级书法家协会会员的百人以上,学生每年参加各级书法比赛获奖的人数众多,总量在全市同类培训机构中遥遥领先,近7年家长有反馈
      的获奖数不完全统计:2013年36个,2014年41个,2015年39个,2016年52个,2017年46个,2018年50个,2019年53个,这些数据都有奖状照片或者复
      印件为证,欢迎查证。
      
    </p>

    </div>
 <img src="../assets/certificate.png" style="width:100%;">
  <h2 class="h2-title">黄志刚先生简介</h2>
    <div style="width:95%;padding-left: .5em;">
    <p class="txt-p">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;黄志刚,字铁君,囊山居士,涵海楼主,福建省莆田市涵江区人,省书法家协会会员,莆田市书法
      法家协会副主席,涵江区书法家协会主席。家学渊源,幼承庭训、曾研习历代书法家碑帖刻石,诸体皆有所成,尤善楷书,以唐代书法家欧阳询为宗,精研最深,获益甚多。作品《祖国万岁展览》获金
      奖,《首届需子牛杯大展》中获优秀奖,作品多次在国内外大型书展中获奖,曾在多家报刊杂志发表报导,作品传略被载入《当代书法家大成》和《世界名人辞典》等辞书,作品流传海内外。
    </p>
  </div>
   <h2 class="h2-title">课程设置及类别</h2>
    <div style="width:95%;padding-left: .5em;">
      <p style="text-align:left;">一、硬笔班</p>
   
    <p class="txt-p" style="display: flex;"><span style="width:6em">1、初级班：</span>
    <span style="width:18em">坐姿握姿、书法礼仪、控笔、笔画笔顺、简单字字迹工整等;
    </span></p>
    <p class="txt-p" style="display: flex;"><span style="width:6em">2、中级班：</span>
    <span style="width:18em">偏旁部首、常见结构、笔画细分、常用字、卷面工整等;
    </span></p>
    <p class="txt-p" style="display: flex;"><span style="width:6em">3、提高班：</span>
    <span style="width:18em">间架结构、章法布局、书法理论、作品创作、参赛必备知识等;
    </span></p>
    
    <p class="txt-p" style="display: flex;"><span style="width:8em"><p style="margin:0;">二、毛笔班：</p></span>
    <!-- <p style="margin:0;text-align:right;color:red;">(推荐学习)&nbsp;&nbsp;</p>
    <span style="width:14em">以毛笔为基础,意在学好硬笔,事半功备;
    </span> -->
      </p>
    <p class="txt-p" style="display: flex;"><span style="width:6em">1、初级班：</span>
    <span style="width:18em">坐姿握姿、书法礼仪、控笔、笔画笔顺、简单字字迹工整等;
    </span></p>
    <p class="txt-p" style="display: flex;"><span style="width:6em">2、中级班：</span>
    <span style="width:18em">偏旁部首、常见结构、笔画细分、常用字、卷面工整等;
    </span></p>
    <p class="txt-p" style="display: flex;"><span style="width:6em">3、提高班：</span>
    <span style="width:18em">间架结构、章法布局、书法理论、作品创作、参赛必备知识等;
    </span></p>
      <p style="text-align:left;">三、毛笔创作班</p>
    
    <p class="txt-p" style="display: flex;"><span style="width:8em">1、名贴临幕班：</span>
    <span style="width:15em">历代楷书名贴临幕、章法布局、书写整体风格;
    </span></p>
    <p class="txt-p" style="display: flex;"><span style="width:8em">2、创作参赛班：</span>
    <span style="width:15em">章法布局、书写整体风格、作品创作、参赛必备知识等;
    </span></p>
    <!-- <p class="txt-p" style="display: flex;"><span style="width:6em">3、隶书班：</span>
    <span style="width:18em">隶书笔画、间架结构、章法布局、书写整体风格等;
    </span></p>
    <p class="txt-p" style="display: flex;"><span style="width:6em">4、篆书班：</span>
    <span style="width:18em">篆书笔画、间架结构、篆刻基础等;
    </span></p>
    <p class="txt-p" style="display: flex;"><span style="width:6em">5、行书班：</span>
    <span style="width:18em">行书笔画、间架结构、章法布局、书写整体风格等;
    </span></p> -->
  </div>
  
    <img src="../assets/scanning.png" style="width:10em;margin-top:2em;margin-bottom:1em;">
    <div style="width:95%;padding-left: .5em;">
    <p class="txt-p">办学点:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="h2-title" style="font-size:26px;" >15659571026</span>
      
    </p>
    <p class="txt-p">一、莆田市观桥佳园2楼写字楼201室</p>
    <p class="txt-p">二、莆田市荔能华景城商场3楼</p>
    <p class="txt-p">三、涵江区第一实验小学大门正对面</p>
    <p class="txt-p">四、莆田市涵江区沃尔玛商场外围一层店面288-16</p>
    <p class="txt-p">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号,地下停车场入口处旁</p>
    <p>
  <a href="https://beian.miit.gov.cn" style="text-decoration: none;    color: #000000;">闽ICP备15015959号-3</a>

    </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.txt-p{
  text-align: left;font-size: 0.9em;    margin: 0.5em 0.7em;
  line-height: 2em;color: #000;
}
 .h2-title{color:red;font-size: 1.5em;font-family: STXingkai;}
 .p-content{color:red;}
.col3{display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-line-pack: start;
    align-content: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    -ms-flex-wrap: wrap;
    width: 95%;
    margin-left: 2.5%;
    flex-wrap: wrap;}
    .col3 img{
      width: 32%;
    margin-bottom: .5rem;
    }
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue